import React, { useState } from 'react'

import { Button, Form, InputGroup, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';

import plusIcon from '../../../assets/icons/plus-button.png';
import minusIcon from '../../../assets/icons/minus.png';

const RedTrustCertificates = ({ parentState, authorizeRedTrustCertificate, unauthorizeRedTrustCertificate, synchronizeRedTrustCertificates, children }) => {
  const [RTuser, setRTuser] = useState('');
  const [RTpassword, setRTpassword] = useState('');
  const [RTdomain, setRTdomain] = useState('');

  const [showAuthorizeModal, setShowAuthorizeModal] = useState(false);
  
  const { t } = useTranslation();
  const certsNotAvailable = <p>{t('certificates.certificate-not-available')}</p>;

  const RedTrustColumns = [
    {
        dataField: 'certalias',
        text: t('certificates.certificate'),
        align: 'left',
        sort: true,
        headerAlign: 'left',
        headerClasses: 'headerClass1',
        style: { verticalAlign: 'middle' }
    },
    {
        dataField: 'ExpirationDate',
        text: t('certificates.certificate-date'),
        align: 'left',
        sort: true,
        headerAlign: 'left',
        headerClasses: 'headerClass2',
        style: { verticalAlign: 'middle' }
    }
];

  const {
    RedTrustIsAuthorized,
    certificatesOrdered: { RedTrust }
  } = parentState;

  if (RedTrust.length === 0) {
    RedTrust.push({
        GUID: 'placeholder',
        certalias: '---',
        ExpirationDate: '---',
    })
  }

  return (
    <div className="table-container">
      <div className='table-container-header'>
        {RedTrustIsAuthorized ? (
          <button
            className="new-create-button"
            onClick={unauthorizeRedTrustCertificate}
          >
            <img src={minusIcon} alt="minus icon" />
            <span>{t("general.unauthorize")}</span>
          </button>
        ) : (
          <button
            className="new-create-button"
            onClick={() => setShowAuthorizeModal(true)}
          >
            <img src={plusIcon} alt="plus icon" />
            <span>{t("general.authorize")}</span>
          </button>
        )}
        {RedTrustIsAuthorized && children}
      </div>
      <Modal
        show={showAuthorizeModal}
        onHide={() => setShowAuthorizeModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("general.authorize")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3">
            <InputGroup.Prepend>
              <InputGroup.Text id="red-trust-user">
                {t("general.user")}
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              required
              type="text"
              aria-label="Default"
              aria-describedby="red-trust-user"
              value={RTuser}
              onChange={(e) => setRTuser(e.target.value)}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Prepend>
              <InputGroup.Text id="red-trust-domain">
                {t("general.domain")}
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              required
              type="text"
              aria-label="Default"
              aria-describedby="red-trust-domain"
              value={RTdomain}
              onChange={(e) => setRTdomain(e.target.value)}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Prepend>
              <InputGroup.Text id="red-trust-password">
                {t("general.password")}
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              required
              type="password"
              aria-label="Default"
              aria-describedby="red-trust-password"
              value={RTpassword}
              onChange={(e) => setRTpassword(e.target.value)}
            />
          </InputGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            id="authorizeRT"
            className="btn btn-primary signature-image"
            onClick={() => {
                setShowAuthorizeModal(false);
                authorizeRedTrustCertificate({ RTuser, RTpassword, RTdomain });
              }
            }>
            {t("general.confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
      {RedTrustIsAuthorized && (
        <div>
          {RedTrust.length === 0 && certsNotAvailable}
          <ToolkitProvider
            keyField="GUID"
            data={RedTrust}
            columns={RedTrustColumns}
          >
            {(props) => (
              <div>
                <BootstrapTable striped {...props.baseProps} />
              </div>
            )}
          </ToolkitProvider>
          <div className="rt-buttons-container">
            <Button
              type="button"
              id="synchronizeRedTrust"
              className="btn btn-primary signature-image"
              onClick={() =>
                synchronizeRedTrustCertificates({
                  RTuser,
                  RTpassword,
                  RTdomain,
                })
              }
              style={{ marginLeft: 10 }}
            >
              {t("general.synchronize")}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RedTrustCertificates;